// Human-readable names for "coded" DICOM UIDs (entries in the DICOM standard
// registry, PS3.6) — SOP Classes and Transfer Syntaxes. Identifier UIDs
// (Study/Series/SOP/Frame-of-Reference) are NOT here: they carry no meaning.

const UID_NAMES: Record<string, string> = {
  // ── SOP Classes (Storage) ────────────────────────────────────────────────
  '1.2.840.10008.5.1.4.1.1.77.1.6': 'VL Whole Slide Microscopy Image',
  '1.2.840.10008.5.1.4.1.1.77.1.2': 'VL Microscopic Image',
  '1.2.840.10008.5.1.4.1.1.77.1.1': 'VL Endoscopic Image',
  '1.2.840.10008.5.1.4.1.1.77.1.3': 'VL Slide-Coordinates Microscopic Image',
  '1.2.840.10008.5.1.4.1.1.91.1': 'Microscopy Bulk Simple Annotations',
  '1.2.840.10008.5.1.4.1.1.2': 'CT Image',
  '1.2.840.10008.5.1.4.1.1.4': 'MR Image',
  '1.2.840.10008.5.1.4.1.1.1': 'Computed Radiography Image',
  '1.2.840.10008.5.1.4.1.1.1.1': 'Digital X-Ray Image (For Presentation)',
  '1.2.840.10008.5.1.4.1.1.6.1': 'Ultrasound Image',
  '1.2.840.10008.5.1.4.1.1.7': 'Secondary Capture Image',
  '1.2.840.10008.5.1.4.1.1.66.4': 'Segmentation',
  '1.2.840.10008.5.1.4.1.1.88.11': 'Basic Text SR',
  '1.2.840.10008.5.1.4.1.1.88.22': 'Enhanced SR',
  '1.2.840.10008.5.1.4.1.1.88.33': 'Comprehensive SR',

  // ── Transfer Syntaxes ────────────────────────────────────────────────────
  '1.2.840.10008.1.2': 'Implicit VR Little Endian',
  '1.2.840.10008.1.2.1': 'Explicit VR Little Endian',
  '1.2.840.10008.1.2.1.99': 'Deflated Explicit VR Little Endian',
  '1.2.840.10008.1.2.2': 'Explicit VR Big Endian',
  '1.2.840.10008.1.2.4.50': 'JPEG Baseline (8-bit, lossy)',
  '1.2.840.10008.1.2.4.51': 'JPEG Extended (12-bit, lossy)',
  '1.2.840.10008.1.2.4.57': 'JPEG Lossless',
  '1.2.840.10008.1.2.4.70': 'JPEG Lossless (SV1)',
  '1.2.840.10008.1.2.4.80': 'JPEG-LS Lossless',
  '1.2.840.10008.1.2.4.81': 'JPEG-LS Near-Lossless',
  '1.2.840.10008.1.2.4.90': 'JPEG 2000 (lossless)',
  '1.2.840.10008.1.2.4.91': 'JPEG 2000',
  '1.2.840.10008.1.2.5': 'RLE Lossless',
};

/** Friendly name for a coded UID, or undefined if it's not a known standard UID. */
export function uidName(uid: string | undefined): string | undefined {
  return uid ? UID_NAMES[uid] : undefined;
}
